import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwSearchBox extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            minChars : 3,
            searchDelay: 500,
            hideDelay: 300,
            busyClass: 'is-busy',
            expandedClass: 'is-expanded',
            hasResultClass: 'has-result',
            openHandleClass: 'searchbox__icon',
            inputClass: 'searchbox__input',
            resultLayerClass: 'searchbox__result',
            ismobile:false,
        }
        this.arrow       = {left: 37, up: 38, right: 39, down: 40 };
        this.inputField  = null;
        this.openHandle  = null;
        this.resultLayer = null;
        this.ajaxRequest = null;
        this.searchTimer = null;
        this.hasResultLayerBeenClicked = false;
    }

    __PageReady(){
        this.inputField  = this.$el.find("."+this.config.inputClass);
        this.openHandle  = this.$el.find("."+this.config.openHandleClass);
        this.resultLayer = this.$el.find("."+this.config.resultLayerClass);

        if(!this.config.ismobile) {
            this.openHandle.on("click", () => {this.openCloseBox();});
        }
        this.inputField.keyup(this.keyupHandler.bind(this));
        this.inputField.blur(this.resetSearchBox.bind(this));
        this.resultLayer.on("click",() => {this.resultLayerClicked();});
    }

     openCloseBox(){
        this.$el.toggleClass(this.config.expandedClass);
        if(this.$el.hasClass(this.config.expandedClass)){
            this.inputField.focus();
        }
    }

    resultLayerClicked(e){
        this.hasResultLayerBeenClicked = true;
    }

    resetSearchBox(){
        setTimeout(() =>{
            if(!this.hasResultLayerBeenClicked) {
                if(this.ajaxRequest) this.ajaxRequest.abort();
                this.$el.removeClass(this.config.busyClass);
                if(!this.config.ismobile) this.$el.removeClass(this.config.expandedClass);
                this.$el.removeClass(this.config.hasResultClass);
                this.inputField.prop('value','');
            }
        },this.config.hideDelay);
    }

    keyupHandler(e){
        if(e==undefined || e.which==this.arrow.left || e.which==this.arrow.right || e.which==this.arrow.up || e.which==this.arrow.down) return;


        //LETTERS TYPED
        clearTimeout(this.searchTimer);
        var term=this.inputField.prop("value");
        //emptyLayer();
        if(term.length>=this.config.minChars){
            this.searchTimer = setTimeout(
                this.sendRequest.bind(this),
                this.config.searchDelay
            );
        }else{
            if(term.length<this.config.minChars){
                this.$el.removeClass(this.config.hasResultClass);
            }
        }
    }

    sendRequest(){

        if(this.ajaxRequest) this.ajaxRequest.abort();

        this.$el.addClass(this.config.busyClass);

        var arg = {};
        arg.requestParameter = {q:encodeURIComponent(this.inputField.prop("value"))};

        this.ajaxRequest = $.ajax({
                                 type:"GET",
                                 url:this.config.ajaxroute,
                                 data:arg,
                             })
                       .done(this.parseAnswer.bind(this))
                       .fail( )
                       .always( (data) => { this.$el.removeClass(this.config.busyClass); });

    }

    parseAnswer(data){
        this.resultLayer.html(data);
        this.$el.addClass(this.config.hasResultClass);
        $('.searchbox__result').addClass('auwInDown');
    }



}
